import React from 'react';
import { IonPage, IonContent } from '@ionic/react';
import './LoadingPage.css';

import { logo } from '../../theme/images';
import Spinner from '@acri-tools/react-tools/components/Spinner/Spinner';

export default () => (
    <IonPage >
        <IonContent >
            {/* <div id="loading-page-custom">
                <img className="loading-logo" alt={"Example logo"} src={logo}/>
                <p>Sentinel-2 Anomaly Database</p>
                <Spinner white height={30}/>
            </div> */}
        </IonContent>
    </IonPage>
);